
export default {
  computed: {
    logo() {
      return this.$screen.md ? '/logo.svg' : '/logo-small.svg'
    }
  },
  vessel: {
    link: {
      $attrs: 'all',
      display: 'block'
    }
  }
}
